import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "app",
  class: "container-fluid"
}
const _hoisted_2 = { class: "main-view-wrapper" }
const _hoisted_3 = {
  class: "modal fade",
  id: "notificationModal",
  tabindex: "-1",
  "aria-labelledby": "Notification",
  "aria-hidden": "true"
}
const _hoisted_4 = { class: "modal-dialog" }
const _hoisted_5 = { class: "modal-content" }
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-6 text-start" }
const _hoisted_9 = { class: "col-6 text-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createBlock(_component_router_view, {
        key: _ctx.$route.path
      }))
    ]),
    _cache[4] || (_cache[4] = _createElementVNode("button", {
      class: "btn btn-primary d-none",
      id: "notificationModalOpener",
      type: "button",
      "data-bs-toggle": "modal",
      "data-bs-target": "#notificationModal"
    }, "Notification", -1)),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _cache[3] || (_cache[3] = _createElementVNode("button", {
              type: "button",
              class: "d-none",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              id: "notificationModalDismiss"
            }, null, -1)),
            _createElementVNode("p", null, _toDisplayString(_ctx.messagePayload && _ctx.messagePayload.notification ? _ctx.messagePayload.notification.body : ''), 1),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openNotificationUrl()))
                }, "Zobrazit"),
                _cache[2] || (_cache[2] = _createTextVNode("   "))
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-secondary",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeNotification()))
                }, "Zavřít")
              ])
            ])
          ])
        ])
      ])
    ]),
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "text-center position-fixed bg-white credits" }, "ABRA Software", -1))
  ]))
}